// extracted by mini-css-extract-plugin
export default {"contentContainer":"styles_contentContainer__9aPAi","logo":"styles_logo__E7579","cardContainer":"styles_cardContainer__ESjhv","textWrapper":"styles_textWrapper__w940Z"};